import 'dayjs/locale/cs'
import { Dayjs } from 'dayjs'

const cs = {
  calendar: {
    sameDay: '[dnes v] LT',
    nextDay: '[zítra v] LT',
    nextWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
          return now.format('[v neděli v] LT')
        case 1:
        case 2:
          return now.format('[v] dddd [v] LT')
        case 3:
          return now.format('[ve středu v] LT')
        case 4:
          return now.format('[ve čtvrtek v] LT')
        case 5:
          return now.format('[v pátek v] LT')
        case 6:
          return now.format('[v sobotu v] LT')
      }
    },
    lastDay: '[včera v] LT',
    lastWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
          return now.format('[minulou neděli v] LT')
        case 1:
        case 2:
          return now.format('[minulé] dddd [v] LT')
        case 3:
          return now.format('[minulou středu v] LT')
        case 4:
        case 5:
          return now.format('[minulý] dddd [v] LT')
        case 6:
          return now.format('[minulou sobotu v] LT')
      }
    },
    sameElse: 'L'
  }
}

export default cs
